"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReactPainter_1 = require("./ReactPainter");
var ReactPainter_2 = require("./ReactPainter");
exports.ReactPainter = ReactPainter_2.ReactPainter;
exports.default = ReactPainter_1.ReactPainter;
//# sourceMappingURL=index.js.map